var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0038 27.6449H25.8998V18L18.0003 25.7944L10.1008 18V27.6449H2.99686H2.76953C5.95208 32.6355 11.5784 36 18.0003 36C24.4222 36 30.0485 32.6916 33.2311 27.6449H33.0038Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35962 23.5385V8.70755L18 20.224L29.6404 8.70755V23.5385H35.0347C35.6593 21.7408 36 19.8307 36 17.8083C36 7.97723 27.9369 0 18 0C8.06309 0 0 7.97723 0 17.8083C0 19.8307 0.340694 21.7408 0.9653 23.5385H6.35962Z",
    fill: "#FF6B01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonero);
export default __webpack_public_path__ + "static/media/monero.e27e617e2092f22ada3135e5eb13da79.svg";
export { ForwardRef as ReactComponent };